import { MonoTypeOperatorFunction, of } from 'rxjs';
import { concatMap, delay, retryWhen } from 'rxjs/operators';

const retryApiError = (delayTime: number, exceedAttemptLimit: number): MonoTypeOperatorFunction<unknown> =>  {
  let retries = 0;
  return retryWhen((error) => {
    return error.pipe(
      delay(delayTime),
      concatMap((err) => {
        retries = retries + 1;
        if (retries < exceedAttemptLimit) {
          return of(err);
        } else {
          throw err;
        }
      })
    );
  });
};

export default retryApiError;
